import { useMutation } from '@tanstack/react-query';

import BackendService from '../services/backendService';
import { Template } from '../services/TemplateService/Template.type';

function useExport() {
  const {
    mutate: createToken,
    isSuccess: createTokenSuccess,
    isLoading: isCreatingToken,
    data: tokenResponse,
  } = useMutation(
    ({
      email,
      activeTenantId,
    }: {
      email?: string;
      activeTenantId?: string;
      onSuccessFunction?: (data: Template) => void;
    }) => BackendService.instance.export.createToken({ activeTenantId, email }),
  );

  const {
    mutate: checkToken,
    isSuccess: checkTokenSuccess,
    isLoading: isCheckingToken,
    data: checkTokenResponse,
    isError: isCheckTokenError,
  } = useMutation(
    ({
      token,
      activeTenantId,
    }: {
      token: string;
      activeTenantId?: string;
      onSuccessFunction?: (data: Template) => void;
    }) => BackendService.instance.export.checkToken({ activeTenantId, token }),
  );

  const {
    mutate: executeExport,
    isSuccess: executeExportSuccess,
    isLoading: isExecutingExport,
    error: executeExportError,
  } = useMutation(
    ({
      token,
      activeTenantId,
    }: {
      token: string;
      activeTenantId?: string;
      onSuccessFunction?: (data: Template) => void;
    }) => BackendService.instance.export.execute({ activeTenantId, token }),
  );

  return {
    createToken,
    createTokenSuccess,
    isCreatingToken,
    isCheckTokenError,
    tokenResponse,
    checkToken,
    checkTokenSuccess,
    isCheckingToken,
    checkTokenResponse,
    executeExport,
    executeExportSuccess,
    isExecutingExport,
    executeExportError,
  };
}

export default useExport;
